import { render, staticRenderFns } from "./EditMainCategoryDialog.vue?vue&type=template&id=0ab73725&scoped=true"
import script from "./EditMainCategoryDialog.vue?vue&type=script&lang=js"
export * from "./EditMainCategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./EditMainCategoryDialog.vue?vue&type=style&index=0&id=0ab73725&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab73725",
  null
  
)

export default component.exports